import { render, staticRenderFns } from "./ticket-detail.vue?vue&type=template&id=199316c0&"
import script from "./ticket-detail.vue?vue&type=script&lang=js&"
export * from "./ticket-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CDivider: require('@chakra-ui/vue').CDivider, CGrid: require('@chakra-ui/vue').CGrid})
